import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { userNotificationPreferencesBackend } from './user-notification-preferences.backend';
import { userNotificationPreferencesReducer } from './user-notification-preferences.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'userNotificationPreferences',
      userNotificationPreferencesReducer,
    ),
    BackendModule.forFeature(
      'userNotificationPreferences',
      userNotificationPreferencesBackend,
    ),
  ],
})
export class DatastoreUserNotificationPreferencesModule {}
